import PortalIdParser from 'PortalIdParser';
import enviro from 'enviro';
import { PROD_53, QA_53 } from '../../constants/Portal53';
export const isBETPortal = () => PortalIdParser.get() === (enviro.isQa() ? QA_53 : PROD_53);